<template>
  <main class="coordinator-toolbar mt-1">
    <span>
      <div class="subtitle is-7 has-text-grey is-marginless is-hidden-mobile">PROJECT</div>
      <div class="subtitle is-7 has-text-grey is-marginless is-hidden-mobile">COORDINATOR</div>
    </span>
    <div class="project-id" data-balloon="Used for support purposes" data-balloon-pos="up">
      <strong>Project ID:</strong> {{project.id}}
    </div>
    <button class="toolbar-button" :data-balloon="$t('coordinatorToolbar.hide')" data-balloon-pos="up" tabindex="0" @keypress.enter.space="updateFlags('hidden')" @click="updateFlags('hidden')">
      <strong>{{ project.isHidden ? 'Unhide' : 'Hide' }}</strong>
      <i :class="{'fal fa-eye': project.isHidden, 'fal fa-eye-slash': !project.isHidden}" :aria="project.isHidden ? 'Unhide Project' : 'Hide Project'"></i>
    </button>
    <button class="toolbar-button" :data-balloon="$t('coordinatorToolbar.lock')" data-balloon-pos="up" tabindex="0" @keypress.enter.space="updateFlags('editable')" @click="updateFlags('editable')">
      <strong>{{ project.isEditable ? 'Lock' : 'Unlock' }}</strong>
      <i :class="{'fal fa-lock': project.isEditable, 'fal fa-unlock': !project.isEditable}" :aria="project.isEditable ? 'Make Uneditable' : 'Make Editable'"></i>
    </button>
    <button v-if="!$isOhioScience && !isAdmin" class="toolbar-button" :data-balloon="$t('coordinatorToolbar.submit')" data-balloon-pos="up" tabindex="0" @keypress.enter.space="updateFlags('submitted')" @click="updateFlags('submitted')">
      <strong>{{ project.submitted ? 'Unsubmit' : 'Submit' }}</strong>
      <i :class="{'fal fa-upload': project.submitted, 'fal fa-download': !project.submitted}" :aria="project.submitted ? 'Unsubmit' : 'Submit'"></i>
    </button>
    <button class="toolbar-button" :data-balloon="$t('coordinatorToolbar.private')" data-balloon-pos="up" tabindex="0" @keypress.enter.space="updateFlags('private')" @click="updateFlags('private')">
      <strong>{{ project.isPrivate ? 'Make Public' : 'Make Private' }}</strong>
      <i :class="{'fal fa-users': project.isPrivate, 'fal fa-users-slash': !project.isPrivate}" :aria="project.submitted ? 'Unsubmit' : 'Submit'"></i>
    </button>
  </main>
</template>

<script>

import state from '../state'

import componentState from '@/mixins/component-state'
import auth from '@/mixins/auth'

export default {
  mixins: [componentState, auth],
  data: function () {
    return {
      error: ''
    }
  },
  computed: {
    project: function () {
      return this._get(state.project.id) ? this.$store.getters.project(this._get(state.project.id)) || {} : {}
    }
  },
  methods: {
    updateFlags: function (context) {
      if (!context) {
        return
      }
      const params = {
        id: this.project.id,
        isHidden: this.project.isHidden,
        isEditable: this.project.isEditable,
        submitted: this.project.submitted,
        isPrivate: this.project.isPrivate
      }

      switch (context) {
        case 'hidden':
          params.isHidden = !params.isHidden
          break
        case 'editable':
          params.isEditable = !params.isEditable
          break
        case 'submitted':
          params.submitted = !params.submitted
          break
        case 'private':
          params.isPrivate = !params.isPrivate
          break
      }

      this.$store.dispatch('updateProjectFlags', params).then(() => {
      }, (error) => {
        this.error = error.message
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.coordinator-toolbar {
  background-color: var(--background-secondary);
  color: #7a7a7a;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem;
}

.toolbar-button{
  padding: 4px 6px;
  background-color: $primary;
  color: white;
  border-radius: 2px;
  border: none;
  cursor: pointer;
  strong {
    color: white;
  }
}

/* use same color as button for popup*/
[data-balloon]:after {
  background: $secondary;
}
/* hide triangle image since we cant change that color and draw our own*/
[data-balloon]:before {
  background: none;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-top: 10px solid $secondary;
}

.project-id{
  cursor: default;
  font-size: 0.8rem;
}
</style>
